import { createStore, createHook, createActionsHook, type StoreActionApi } from 'react-sweet-state';

export interface GeneratedTitleState {
	generatedTitle: string;
	trackAIResultViewStored: (attribute: any) => void;
	// For title generation on paste (standard pages only)
	generatedTitleFromPaste: string;
	fireResultAnalyticsFromPaste: () => void;
}

export const initialState: GeneratedTitleState = {
	generatedTitle: '',
	trackAIResultViewStored: () => {},
	generatedTitleFromPaste: '',
	fireResultAnalyticsFromPaste: () => {},
};

const NAME = 'GENERATED_TITLE_STORE';

export const actions = {
	setGeneratedTitle:
		(newTitle: string) =>
		({ setState }: StoreActionApi<GeneratedTitleState>) => {
			setState({ generatedTitle: newTitle });
		},
	setTrackAIResultViewStored:
		(trackAIResultViewHook: (attribute: any) => void) =>
		({ setState }: StoreActionApi<GeneratedTitleState>) => {
			setState({ trackAIResultViewStored: trackAIResultViewHook });
		},
	setGeneratedTitleFromPaste:
		(newTitle: string) =>
		({ setState }: StoreActionApi<GeneratedTitleState>) => {
			setState({ generatedTitleFromPaste: newTitle });
		},
	setFireResultAnalyticsFromPaste:
		(fireResultAnalytics: () => void) =>
		({ setState }: StoreActionApi<GeneratedTitleState>) => {
			setState({ fireResultAnalyticsFromPaste: fireResultAnalytics });
		},
	clearGeneratedTitleFromPaste:
		() =>
		({ setState }: StoreActionApi<GeneratedTitleState>) => {
			setState({ generatedTitleFromPaste: '', fireResultAnalyticsFromPaste: () => {} });
		},
};

const GeneratedTitleStore = createStore({
	name: NAME,
	initialState,
	actions,
});

export const useGeneratedTitle = createHook(GeneratedTitleStore);
export const useGeneratedTitleActions = createActionsHook(GeneratedTitleStore);
